window.validator = {
	validEmail: function validEmail(email) {

		var re = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;

		return re.test(email);
	},

	// Check user permission in global user var
	can: function can(args) {

		if (!window.user || !window.user.can) {
			return false;
		}

		var re = [];

		args.forEach(function (p) {
			if (window.user.can[p]) {
				re.push(p);
			}
		});

		return re.length ? true : false;
	},
	propertyName: function propertyName() {

		var propertyName = localStorage.getItem('property-name');

		return propertyName;
	},
	hideInProd: function hideInProd() {

		var d = process.env.MIX_APP_SHOW_DEV; // only show on dev

		return d.toLowerCase() == 'true' ? true : false;
	},
	role: function role() {
		return window.user.role;
	}
};


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/validator.js
// module id = 9R8V
// module chunks = 0 1